import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiBase } from "../utils/apiBase";
import { queryClient, REFERENCE_QUERY_OPTIONS } from "./queryClient";

export const usersQuery = queryOptions({
  queryKey: ["users"],
  queryFn: () => apiBase.get("users").then((res) => res.data),
  ...REFERENCE_QUERY_OPTIONS,
  meta: { errorMessage: "Failed to load users." },
});

export const useUsers = () => useQuery(usersQuery);
export const invalidateUsers = () =>
  queryClient.invalidateQueries({ queryKey: usersQuery.queryKey });
